import * as Y from 'yjs';

import { WidgetType } from 'shared/widgets/utils';

import { manifestLocales } from './manifest.locales';
import { InitializePropsOptions, ManifestInitializedProps } from '@/types/ManifestType';
import { genRandId } from '@/utils/core.utils';
import { htmlToXmlFragment } from '@/utils/tiptap';

export function createNewSubmitPageSatisfactionSurvey(
  options: Omit<InitializePropsOptions, 'isPlenaryLesson'>
): ManifestInitializedProps {
  const { locale } = options;
  const { howWasActivity } = manifestLocales.submitPageSatisfactionSurvey;
  const id = genRandId();
  const fragment = htmlToXmlFragment(`<p>${howWasActivity[locale]}</p>`);
  return [
    {
      id,
      contentObjectData: new Y.Map([
        ['id', id],
        ['type', WidgetType.SubmitPageSatisfactionSurvey],
        ['children', new Y.Array()],
        ['fragment', fragment]
      ])
    }
  ];
}
